export default __webpack_public_path__ + "static/media/impact.7baaa601.svg";